import { render, staticRenderFns } from "./VoyageForm.vue?vue&type=template&id=2b76496b&scoped=true&"
import script from "./VoyageForm.vue?vue&type=script&lang=js&"
export * from "./VoyageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76496b",
  null
  
)

export default component.exports